import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import type { LinkAnmeldung } from '../../lib/planung';

/**
 * Wer ist gerade angemeldet? `undefined` = noch unbekannt, `null` = niemand,
 * sonst die Nutzer-ID. Die Feedback-Abfragen hängen daran (queryKey): Nach
 * An- oder Abmelden lädt die Seite neu und der Hinweis passt sich an.
 * Im Callback keine weiteren Supabase-Aufrufe (Auth-Lock) — nur merken.
 */
export function useAnmeldeKennung(): string | null | undefined {
  const [kennung, setKennung] = useState<string | null | undefined>(supabase ? undefined : null);
  useEffect(() => {
    if (!supabase) return;
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setKennung(session?.user.id ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);
  return kennung;
}

/**
 * Kurzer Satz für die Kommentarspalte, wenn Schreiben gerade nicht geht:
 * in der Admin-Ansicht (Migration 0052), sonst nur noch als Rückfall — ohne
 * passende Anmeldung zeigt der Link seit 0051 gar keine Mail, sondern die
 * Anmeldeseite. name = Name der Person, der der Link gehört.
 */
export function nurLesenText(a: LinkAnmeldung, name?: string | null): string {
  if (a.status === 'admin_ansicht') return `Admin-Ansicht: Kommentieren geht hier nur für ${name?.trim() || 'die Person'} selbst — Du kommentierst in der Werkstatt.`;
  if (a.status === 'keine_adresse' || a.status === 'nicht_erlaubt') return 'Für diesen Link ist keine passende Adresse hinterlegt — kommentieren geht nicht. Bitte melde Dich bei der Redaktion.';
  if (a.status === 'andere_adresse') return 'Du bist nicht mit dem Google-Konto angemeldet, dem dieser Link gehört. Zum Kommentieren meldest Du Dich oben damit an.';
  return 'Zum Kommentieren, Markieren oder Ändern meldest Du Dich oben mit Google an.';
}
